import { render, staticRenderFns } from "./concernedContactsTable.vue?vue&type=template&id=04b4dcc0"
import script from "./concernedContactsTable.vue?vue&type=script&lang=js"
export * from "./concernedContactsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports